<template>
  <div class="animated fadeIn faster">
    <p class="siimple-h5">
      Hei! 👋 Velkommen til
      <a href="https://www.novanet.no" class="siimple-link" target="_blank">Novanets</a>
      påskenøtter!
    </p>
    <p class="siimple-p siimple--pt-2 siimple--mb-4">
      Årets utgave er en god blanding av emoji-quizer med ulik vanskelighetsgrad. Mens du nyter påsken, enten du er på fjellet, hytta eller utenlands, håper vi at våre påskenøtter vil hjelpe deg til å koble av, samtidig som du får litt hodebry. 💡
      Blant de med alle riktig blir det trukket en heldig vinner.🏆 Før du går løs på årets oppgaver, her har du tre oppvarmingsspørsmål så du skjønner hva det går i:
    </p>

    <quiz-group disable-ruler class="siimple--mb-4">
      <quiz-item
        :solutions="['københavn']"
        :item="{ id: 1, text: '🚤🏰🧜‍♀️' }"
        heading="Hovedstad"
      />
    </quiz-group>
    <quiz-group disable-ruler class="siimple--mb-4">
      <quiz-item
        :solutions="['mcdonalds', 'macdonalds', 'macern', 'mækkern']"
        :item="{ id: 2, text: '🍔🍟🍦' }"
        heading="Restaurant"
      />
    </quiz-group>
    <quiz-group disable-ruler class="siimple--mb-4">
      <quiz-item
        :solutions="['disneyland']"
        :item="{ id: 3, text: '🐭🎢🏰' }"
        heading="Fornøyelsespark"
      />
    </quiz-group>

    <div class="siimple--mt-4" align="center">
      <p>De var vel greie?</p>
      <p class="siimple-p">
        <router-link class="siimple-btn siimple-btn--primary" to="/oppgaver">Jada! Gi meg mer!</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import QuizGroup from '@/components/QuizGroup';
import QuizItem from '@/components/QuizItem';

export default {
  name: 'Intro',
  components: {
    QuizGroup,
    QuizItem
  }
};
</script>

<style scoped>
.siimple-list {
  max-width: 300px;
  cursor: pointer;
}
.emojirow {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue